var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-achievements-request-preview"},_vm._l((_vm.achievementsLabel),function(tag,index){return _c('a-tag',{key:index},[_vm._v(" "+_vm._s(tag)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }